import React from 'react';

const HeroSkeleton: React.FC = () => {
    return (
        <div className="hero-banner">
            <div className="container hero-grid">
                <div className="hero-content">
                    <div className="skeleton-line skeleton-title" style={{ width: '70%', height: '48px', marginBottom: '20px' }}></div>
                    <div className="skeleton-line skeleton-title" style={{ width: '60%', height: '48px', marginBottom: '24px' }}></div>
                    <div className="skeleton-line" style={{ marginBottom: '12px' }}></div>
                    <div className="skeleton-line" style={{ marginBottom: '12px' }}></div>
                    <div className="skeleton-line skeleton-short" style={{ marginBottom: '24px' }}></div>
                    <div className="skeleton-line" style={{ width: '100%', height: '20px', marginBottom: '12px' }}></div>
                    <div className="skeleton-line" style={{ width: '80%', height: '20px', marginBottom: '32px' }}></div>
                    <div className="skeleton-line" style={{ width: '200px', height: '48px', borderRadius: '8px' }}></div>
                </div>
                <div className="hero-visual">
                    <div className="glass-frame">
                        <div className="skeleton-image" style={{ width: '100%', height: '100%', borderRadius: '12px' }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroSkeleton;
